<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
    <div
      class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
    >
      {{ header }}
    </div>

    <div class="grid grid-cols-2">
      <div class="relative">
        <select
          class="block w-full appearance-none bg-gray-100 border border-gray-700 text-gray-700 py-2 m-2 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="grid-state"
          v-model="selected_role"
        >
          <option disabled value="" selected>Selecteer een rol</option>
          <option
            :value="{ id: role.id, permissions: role.permissions }"
            v-for="role in roles"
            :key="role.id"
          >
            {{ role.role }}
          </option>
        </select>
        <div
          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
        >
          <svg
            class="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            />
          </svg>
        </div>
      </div>
    </div>
    <FormulateForm
      v-model="values"
      :schema="schema"
      @submit="submitHandler"
      v-if="selected_role"
    />
  </div>
</template>

<script>
export default {
  name: "PermissionsCard",
  data: function() {
    return {
      header: "Permissies / rechten",
      selected_role: "",
      values: {},
      disabled: true
    };
  },
  computed: {
    schema: function() {
      let schema = [];
      for (let permission_id in this.permissions) {
        const permission = this.permissions[permission_id];
        const checkbox = {
          type: "checkbox",
          name: permission["permission_id"].toString(),
          inputClass:
            "toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer",
          wrapperClass:
            "relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in",
          elementClass: ""
        };

        const row = {
          component: "div",
          class: "ml-4 my-2 grid grid-cols-2",
          id: Math.random().toString(),
          children: [
            {
              component: "div",
              children: permission["name"]
            },
            checkbox
          ]
        };

        schema.push(row);
      }
      schema.push({
        name: "submit",
        type: "submit",
        "input-class": ["btn", "btn-blue"],
        label: "Opslaan"
      });
      return schema;
    },
    permissions: function() {
      return this.$store.state.backend_data.permissions;
    },
    roles: function() {
      return this.$store.state.backend_data.roles;
    }
  },
  created: function() {
    this.$store.dispatch("loadPermissions");
    this.$store.dispatch("loadRoles");
  },
  methods: {
    submitHandler: function() {
      this.$store.dispatch("updatePermissions", {
        role_id: this.selected_role.id,
        permissions: this.values
      });
    }
  },
  watch: {
    selected_role() {
      this.values = this.selected_role.permissions.reduce(
        (values, current_permission) => ({
          ...values,
          [current_permission["permission_id"].toString()]: true
        }),
        {}
      );
    }
  }
};
</script>

<style>
/* CHECKBOX TOGGLE SWITCH */
/* @apply rules for documentation, these do not work as inline style */
.toggle-checkbox:checked {
  @apply right-0 border-green-400;
  right: 0;
  border-color: #68d391;
}
.toggle-checkbox:checked + label {
  @apply bg-green-400;
  background-color: #68d391;
}

.toggle-checkbox + label {
  @apply block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer;
}

.disabled {
  @apply appearance-none bg-transparent;
}
</style>
